/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorNaryLogicForGraph extends models.QueryOperatorNaryForGraph {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorNaryLogicForGraph");
    }

    getFixupPrototypeFunction() { return QueryOperatorNaryLogicForGraph.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorNaryLogicForGraph>): QueryOperatorNaryLogicForGraph {
        let obj = Object.assign(new QueryOperatorNaryLogicForGraph(), model);
        QueryOperatorNaryLogicForGraph.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorNaryLogicForGraph>): QueryOperatorNaryLogicForGraph {
        if (!model) return null;
        return QueryOperatorNaryLogicForGraph.newInstance(<QueryOperatorNaryLogicForGraph> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorNaryLogicForGraph) {
        if (!obj) return;

        models.QueryOperatorNaryLogicForGraph.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorNaryLogicForGraph): boolean {
        if (models.QueryOperatorNaryForGraph.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorNaryLogicForGraph.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of n-ary operation
     */
    op: models.ResourceNaryQueryCondition;

}
